import { API, graphqlOperation } from "aws-amplify";
import { listMarkedSubjectByUserId } from "graphql/queries";
import {
  MarkedSubject,
  CreateMarkedSubjectInput,
  DeleteMarkedSubjectInput,
  ListMarkedSubjectByUserIdQuery,
  UpdateMarkedSubjectInput,
} from "types/graphqlapi";
import { GraphQLResult } from "@aws-amplify/api-graphql";
import {
  createMarkedSubject,
  deleteMarkedSubject,
  updateMarkedSubject,
} from "graphql/mutations";

/**
 * あるユーザーの最新のチェック付き案件を取得
 * @param user_id
 * @returns
 */
export const fetchMarkedSubjectByUserIdQuery = async (user_id: string) => {
  const result = (await API.graphql(
    graphqlOperation(listMarkedSubjectByUserId, { user_id, limit: 10000 })
  )) as { data: ListMarkedSubjectByUserIdQuery };
  const list = result.data?.listMarkedSubjectByUserId?.items as MarkedSubject[];

  return list;
};

/**
 * 新規作成
 * @param
 * @returns 作成されたデータ
 */
export const createMarkedSubjectMutation = async (
  createMarkedSubjectInput: CreateMarkedSubjectInput
) => {
  const result = (await API.graphql(
    graphqlOperation(createMarkedSubject, {
      input: createMarkedSubjectInput,
    })
  )) as GraphQLResult<{ createMarkedSubject: MarkedSubject }>;

  return result;
};

/**
 * 更新
 * @param
 * @returns 更新されたデータ
 */
export const updateMarkedSubjectMutation = async (
  updateMarkedSubjectInput: UpdateMarkedSubjectInput
) => {
  const result = (await API.graphql(
    graphqlOperation(updateMarkedSubject, { input: updateMarkedSubjectInput })
  )) as GraphQLResult<{ updateMarkedSubject: MarkedSubject }>;

  return result;
};

/**
 * 特定のデータ削除
 * @param
 * @returns 削除されたデータ
 */
export const deleteMarkedSubjectMutation = async (
  deleteMarkedSubjectInput: DeleteMarkedSubjectInput
) => {
  const result = (await API.graphql(
    graphqlOperation(deleteMarkedSubject, {
      input: deleteMarkedSubjectInput,
    })
  )) as GraphQLResult<{ deleteMarkedSubject: MarkedSubject }>;

  return result;
};
